import faq from './guide/faq'
import anchorScroll from './guide/scoped-anchor-scroll'
import beginnerTipstarSlide from './guide/beginner-tipster-slide'
import banner from './guide/banner'

(() => {
  faq();
  anchorScroll('.gu-anchor__link[data-scroll]');
  anchorScroll('.gu-b-tipstar-anchor__link[data-scroll]');
  beginnerTipstarSlide();
  banner();
})();
